import client from "services/client";

const PERMISSIONS_BASE = "/rbac/permissions";

/**
 * Fetches permissions list. Optionally pass roleId to get permissions in context of that role.
 * Returns raw API response; consumer must extract the list from the response.
 * @param {string} [roleId] - Optional role id of the selected role to pass to the API.
 * @returns {Promise} Raw API response.
 */
export const getPermissionsAPI = async (roleId) => {
  let url = `/authorization/permission/getAll?page=1&limit=500`;
  if (roleId) {
    url += `&role_id=${encodeURIComponent(roleId)}`;
  }
  const result = await client.get(url);
  return result;
};

export const createPermissionAPI = async (payload) => {
  const url = `/authorization/permission`;
  const result = await client.post(url, payload);
  return result;
};

/**
 * Fetches permissions for a role. Returns raw response; consumer should read data?.permissions (array of { id, name }).
 * @param {string} roleId - Role ID.
 * @returns {Promise} Raw API response.
 * @throws {Error} When request fails.
 */
export const getRolePermissionsAPI = async (roleId) => {
  if (!roleId) return { data: { permissions: [] } };
  const response = await client.get(`/authorization/roles/${roleId}`, { tokenType: "access" });
  return response;
};

export const updatePermissionAPI = async (roleId, payload) => {
  const url = `/authorization/roles/${roleId}/permission`;
  const result = await client.post(url, payload);
  return result;
};

export const deletePermissionAPI = async (id) => {
  const result = await client.delete(`${PERMISSIONS_BASE}/${id}`);
  return result;
};
